export default __webpack_public_path__ + "static/media/5.df63b6ba.png";